"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeUnfinishedFeatureSettings = void 0;
var tslib_1 = require("tslib");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var disabledUnfinishedFeatureSettings_1 = require("../../../disabledUnfinishedFeatureSettings");
exports.sanitizeUnfinishedFeatureSettings = function (settings) {
    ts_invariant_1.default(settings, "cannot sanitize undefined settings");
    return tslib_1.__assign(tslib_1.__assign({}, settings), disabledUnfinishedFeatureSettings_1.disabledUnfinishedFeatureSettings);
};
//# sourceMappingURL=sanitizeUnfinishedFeatureSettings.js.map